// 计费单

import { HttpGetBillingOrderList, HttpBillOrderOne, HttpBillbatchExec, HttpIgnoreAbnormal } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetBillingOrderList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    // console.log(params)
                    sessionStorage.setItem('billquery', JSON.stringify(params))
                    var url = this.$router.resolve({
                        name: "billorderupdate",
                        params: { type: "query" },
                        query: { id: params.id },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'solobill':
                    this.operate = {
                        show: true,
                        alert: 'primary',
                        params: { id: params },
                        title: this.$t('fbb.costmanage.cost_operate', { defaultValue: '计费操作' }),
                        ajaxRequest: HttpBillOrderOne,
                    }
                    break;
                case 'allBill':
                    this.operate = {
                        show: true,
                        alert: 'primary',
                        params: { ids: params },
                        title: this.$t('fbb.costmanage.cost_operate', { defaultValue: '计费操作' }),
                        ajaxRequest: HttpBillbatchExec,
                    }
                    break;
                case 'abnormal':
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { ids: params },
                        title: this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }),
                        ajaxRequest: HttpIgnoreAbnormal,
                    }
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/billingOrder/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;

            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: row,
                operate: 'query'
            }, {
                label: this.$t('fbb.costmanage.cost', { defaultValue: '计费' }),
                show: status != 2,
                params: id,
                operate: 'solobill'
            }, {
                label: this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }),
                show: status == 3,
                params: id,
                operate: 'abnormal'
            },

            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getWarehouseList', 'getCusproductList', 'getFirstLevelList', 'getBillcusWareList']),
        ...mapGetters('common', ['getStatusList', 'getTypeList', 'getBussinessTypeList', 'getOrderOneTypes']),
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.costmanage.muti_cost', { defaultValue: "批量计费" }),
                    operate: "allBill",
                    theme: "primary",
                    batch: true,
                },
                {
                    name: this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }),
                    operate: "abnormal",
                    theme: "warning",
                    batch: true,
                },
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_warehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_status',
                    show: true,
                    tag: 'vSelect',
                    options: this.getStatusList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.adjustment.bill_type', { defaultValue: "费用类型" }),
                    key: 'EQ_type',
                    more: true,
                    tag: 'vSelect',
                    options: this.getTypeList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.costmanage.work_type', { defaultValue: "业务类型" }),
                    key: 'EQ_businessType',
                    more: true,
                    options: this.getBussinessTypeList,
                    tag: 'vSelect',
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.costmanage.cost_order_type', { defaultValue: "计费单据类型" }),
                    key: 'EQ_billingCategoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getOrderOneTypes,
                    props: {
                        filterable: true,
                    },
                },

                {
                    label: this.$t('fbb.accountmanage.one_level_type', { defaultValue: "一级分类" }),
                    key: 'EQ_firstBillingCategoryId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getFirstLevelList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
                    key: 'EQ_currency',
                    more: true,
                    tag: 'vSelect',
                    options: [
                        { value: 'USD', label: 'USD' }
                    ],
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.adjustment.bill_no', { defaultValue: "计费单号" }),
                    key: 'EQ_orderNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.costmanage.distinguish_number', { defaultValue: "识别号" }),
                    key: 'EQ_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "Tracking No",
                    key: 'EQ_trackingNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.costmanage.exception_tip', { defaultValue: "异常说明" }),
                    key: 'CN_errorMessage',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.update_time', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 80,
                    render: this.getOperateNodes
                }, {
                    title: `${this.$t('global.common.organization', { defaultValue: '组织' })}/${this.$t('global.common.warehouse', { defaultValue: '仓库' })}`,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.organizationName || '--'}</div>
                            <div>{row.orgWarehouseCode || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let status = row.status
                        const { label } = this.getStatusList.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <div>{label}</div>
                    }
                }, {
                    title: `${this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' })}/${this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' })}`,
                    width: 120,
                    render: (h, { row }) => {
                        let businessType = row.businessType
                        const label1 = this.getBussinessTypeList.find(function (item) {
                            return item.value == businessType
                        }) || {};
                        let type = row.type
                        const label2 = this.getTypeList.find(function (item) {
                            return item.value == type
                        }) || {};
                        return <div>
                            <div>{label1.label || '--'}</div>
                            <div>{label2.label || '--'}</div>
                        </div>
                    }
                },
                {
                    title: `${this.$t('fbb.costmanage.cost_order_type', { defaultValue: '计费单据类型' })}/${this.$t('fbb.accountmanage.one_level_type', { defaultValue: '一级分类' })}/${this.$t('fbb.accountmanage_cost_currency', { defaultValue: '计费币种' })}`,
                    width: 200,
                    key: 'billingCategoryType',
                    render: (h, { row }) => {
                        let billingCategoryType = row.billingCategoryType
                        const { label } = this.getOrderOneTypes.find(function (item) {
                            return item.value == billingCategoryType
                        }) || {};
                        return <div>
                            <div>{label || '--'}</div>
                            <div>{row.firstBillingCategoryName || '--'}</div>
                            <div>{row.currency || '--'}</div>
                        </div>
                    }
                },
                {
                    title: `${this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' })}/${this.$t('fbb.costmanage.distinguish_number', { defaultValue: '识别号' })}/Tracking No`,
                    width: 180,
                    render: (h, { row }) => {
                        return <div>
                            <a class="color-link" onClick={this.handleOperates.bind(this, row, 'query')}>{row.orderNo}</a>
                            <div>{row.sourceNo || '--'}</div>
                            <div>{row.trackingNo || '--'}</div>
                        </div>
                    }
                },
                {
                    title: `${this.$t('global.common.line', { defaultValue: '项目' })}/${this.$t('global.common.notes', { defaultValue: '备注' })}`,
                    key: 'lineName',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.lineName || '--'}</div>
                            <div>{row.remark || '--'}</div>
                        </div>
                    }
                },
                {
                    title: `${this.$t('fbb.costmanage.should_take', { defaultValue: '应收' })}/${this.$t('fbb.costmanage.actual_take', { defaultValue: '实收' })}`,
                    key: 'lineName',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.receivable ? row.receivable + row.currency : '--'}</div>
                            <div>{row.receipts ? row.receipts + row.currency : '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.costmanage.exception_tip', { defaultValue: '异常说明' }),
                    key: 'errorMessage',
                },
                {
                    title: `${this.$t('global.common.createdtime', { defaultValue: '创建时间' })}/${this.$t('global.common.update_time', { defaultValue: '更新时间' })}`,
                    width: 150,
                    key: 'createdAt',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.createdAt || '--'}</div>
                            <div>{row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ];
        },
    },
};




